import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { AdminService } from '../../../services/admin.service';
import { AdminOrganizationRow } from '../../../models/admin-organization.model';

/** Compact preview of GET /admin/organizations for the Overview's right rail.
 *  Note: the design reference for this card showed a "Plan" column, which
 *  isn't part of the confirmed organization contract (no subscription-tier
 *  field exists) adapted to billing-exempt/FOCUS instead of inventing one. */
@Component({
  selector: 'app-organizations-preview-card',
  standalone: false,
  templateUrl: './organizations-preview-card.html',
})
export class OrganizationsPreviewCard implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  rows: AdminOrganizationRow[] = [];
  isLoading = true;

  constructor(private adminService: AdminService) {}

  ngOnInit(): void {
    this.adminService.getOrganizations({ perPage: 5 })
      .pipe(takeUntil(this._destroy$))
      .subscribe(({ rows }) => {
        this.rows = rows;
        this.isLoading = false;
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
